import React, { useState, useEffect, ChangeEventHandler, useCallback, useMemo, useRef } from "react";
import { FormEvent, ChangeEvent } from "react";
import { Field } from "../Types/Form";
import Validation from "../FormUi/Validation";

type props = {
    fields: Field[];
    isAllRequire?: boolean;
}

const useDataStore = ({ fields, isAllRequire }: props) => {
    const [isFirts, setIsFirst] = useState(true);
    const [values, setValues] = useState<Record<string, string>>();
    const [prevValues, setPrevValues] = useState<Record<string, string>>();
    const valuesRef = useRef(values);
    const [errors, setErrors] = useState({});
    const prevFieldsRef = useRef(fields);

    useEffect(() => {
        if (isFirts) {
            const newInitialValues = fields.reduce((acc, field) => ({
                ...acc, [field.name]: field.initialValue || null
            }), {});

            setPrevValues(newInitialValues);
            setValues(newInitialValues);

            prevFieldsRef.current = fields;
            setIsFirst(false);
        }
        if (JSON.stringify(prevFieldsRef.current) !== JSON.stringify(fields)) {
            const newInitialValues = fields.reduce((acc, field) => ({
                ...acc, [field.name]: field.initialValue || null
            }), {});

            setPrevValues(newInitialValues);
            setValues(newInitialValues);

            prevFieldsRef.current = fields;
        }
    }, [fields]);

    useEffect(() => { valuesRef.current = values }, [values]);

    const handleChange = (name: string, value: string) => {
        setPrevValues((prev) => ({ ...prev, [name]: values[name] }));

        setValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleCancel = (name: string) => {
        setValues((prev) => ({ ...prev, [name]: prevValues[name] }));
    };

    const getData = (getDataHandle: (arg: any) => any, event?: FormEvent) => {
        if (event) {
            event.preventDefault();
        }

        let newErrors: Record<string, string> = {};

        Object.keys(valuesRef.current).map((key) => {
            const field = fields.find(field => field.name === key);

            if (field?.require || isAllRequire) {
                const error = Validation({ field, value: valuesRef.current[key] });
                newErrors[key] = error;
                setErrors(prev => ({ ...prev, [key]: error }));
            }
        });

        if (Object.values(newErrors).some(err => err)) return;

        getDataHandle(valuesRef.current);
    };

    return { errors, handleChange, values, handleCancel, getData };
    
}

export default useDataStore;
